export default __webpack_public_path__ + "resources/docs/5_debt_management_compressed.70282c0a.pdf";